import { EUserRoles } from '@enums/roles'

export enum routersPath {
  LOGIN_PAGE = '/',
  NOT_FOUND = '/not_found',
  MAIN_PAGE = '/main',
  USERS = '/users',
  CRMS = '/crms',
  SALARY = '/salary',
  EXPENSES = '/expenses',
  INCOMES = '/incomes',
  REPORTS = '/reports',
  REPORT = '/report',
  USER = '/user',
  CRM = '/crm',
  BILLING = '/billing',
  TELEPHONY = '/telephony',
  PHONE_OPERATOR = '/phone_operator',
  TARIFFS = '/tariffs',
  BANNERS = '/banners',
}

export const getDefaultPathByRole = (role?: EUserRoles): routersPath => {
  switch (role) {
    case EUserRoles.BOSS:
      return routersPath.MAIN_PAGE
    case EUserRoles.SUPER_ADMIN:
      return routersPath.MAIN_PAGE
    case EUserRoles.ACCOUNTANT:
      return routersPath.REPORTS
    case EUserRoles.PHONE_OPERATOR:
      return routersPath.PHONE_OPERATOR
    default:
      return routersPath.LOGIN_PAGE
  }
}
